<script setup lang="ts">
import { computed } from 'vue'
import { useField } from 'vee-validate'
import InputText from 'primevue/inputtext'

const props = defineProps<{
  modelValue?: any
  inputName: string
  disabled?: boolean
}>()

const emit = defineEmits(['update:modelValue'])
const { value, errorMessage } = useField<number>(props.inputName)

const computedLengthValue = computed({
  get: () => props.modelValue || '',
  set: (newVal: any) => {
    value.value = newVal
    emit('update:modelValue', newVal)
  }
})
</script>

<template>
  <div class="flex flex-col w-full">
    <label for="totalLength">Total Length:</label>
    <InputText
      id="totalLength"
      :disabled="disabled"
      :invalid="!!errorMessage"
      v-model="computedLengthValue"
      placeholder="Enter total length here"
    />
  </div>
</template>

<style scoped></style>
